

export function lodgingsInteractions() {
  const lodgings = Array.from(document.getElementsByClassName('js-lodgings'));

  if (lodgings) {
    lodgings.forEach((lodging) => {
      const lodgingToggleBtn    = lodging.querySelector('.js-lodgings-toggle');
      const lodgingToggleItems  = Array.from(lodging.getElementsByClassName('js-lodgings-target'));
      const lodgingsLimit      = lodging.dataset.limit ? lodging.dataset.limit : '10'

      const filteringBtns = Array.from(document.getElementsByClassName('js-filter-lodgings'));

      if (filteringBtns) {
        filteringBtns.forEach((filteringBtn) => {
          filteringBtn.addEventListener('click', (evt) => {
            // Remove class active from all buttons once one is clicked
            filteringBtns.forEach((btn) => {
              btn.classList.remove('active');
            })
            filteringBtn.classList.add('active');
            if (lodgingToggleBtn) {
              lodgingToggleBtn.classList.add('hide');
            }

            const activeFilter = filteringBtn.dataset.type;

            for (const lodging of lodgingToggleItems) {
              const lodgingAttrFilter = lodging.dataset.type;

              if (activeFilter === lodgingAttrFilter || lodgingAttrFilter.split('-').includes(activeFilter)) {
                lodging.classList.remove('hide');
              } else if (activeFilter === 'all') {
                lodging.classList.remove('hide');
              } else {
                lodging.classList.add('hide');
              }
            }
          });
        });
      }

      if (lodgingToggleBtn) {
        let listDeployed = false;
        let lodgingPosY;

        const btnTxt = lodgingToggleBtn.querySelector('.lodgings-list__toggle__txt');
        const btnTxtOpen = btnTxt.dataset.openTxt;
        const btnTxtClose = btnTxt.dataset.closeTxt;

        lodgingToggleBtn.addEventListener('click', (evt) => {
          lodgingToggleBtn.classList.toggle('lodgings-list__toggle--active');
          lodgingToggleItems.forEach((lodgingToggleItem, index) => {
            if (lodgingToggleItem.classList.contains('hide')) {
              listDeployed = true;
              lodgingToggleItem.classList.remove('hide');
            } else if (!lodgingToggleItem.classList.contains('hide') && index > lodgingsLimit - 1) {
              listDeployed = false;
              lodgingToggleItem.classList.add('hide');
            }
          });

          if (listDeployed) {
            lodgingPosY = window.scrollY;
            btnTxt.innerHTML = btnTxtClose;
          } else {
            btnTxt.innerHTML = btnTxtOpen;
            window.scroll({
              top: lodgingPosY,
              left: 0,
              behavior: "instant",
            })
          }
        });
      }
    })
  }
}

lodgingsInteractions();
